/**
 * Is the org structure loaded enough to render a dimension-aware grid.
 *
 * `useGetOrganizationStructure` is a React Query hook, so `data` is `undefined` until it resolves — on a
 * cold cache, on a refetch after an error, and on any first render of a page that has just been navigated
 * to. `EmissionsDataGrid` read `organizationStructure.dimensions[dimKey]` with no guard and threw
 * "undefined is not an object (evaluating 't.dimensions')", which React turned into a blank page.
 *
 * **Why a guard and not optional chaining.** The natural-looking fix is wrong:
 *
 *     dimensionsKeys.filter((k) => organizationStructure?.dimensions?.[k] !== null)
 *
 * stops throwing and starts lying — `undefined !== null` is true, so every one of the five dimension keys
 * counts as configured and the grid renders with phantom columns and a wrong `colCount`. A table that is
 * briefly absent is honest; a table with five columns that do not exist is not.
 *
 * `dimensions` is checked and not just the object: the structure arrives as one payload, but a caller that
 * builds a partial object (a test fixture, a future partial fetch) would otherwise pass and throw one line
 * later, which is the same crash with a longer path to it.
 */
export function isOrganizationStructureReady(organizationStructure) {
  return Boolean(organizationStructure && organizationStructure.dimensions);
}
